// extracted by mini-css-extract-plugin
module.exports = {"textArea":"CaptionEditModal--text-area--3Sf8H"};